import { Model } from "@vuex-orm/core"
import Assistant from "@/models/Assistant"
import { notify } from "@/services/notification"

export default class Student extends Model {
  static get entity() {
    return "students"
  }

  static fields() {
    return {
      address: this.attr(""),
      address_other: this.attr(""),
      as_id: this.attr(""),
      assistant: this.belongsTo(Assistant, "as_id"),
      children: this.attr(""),
      date_of_birth: this.attr(""),
      email: this.attr(""),
      entry_date: this.attr(""),
      first_name: this.attr(""),
      full_name: this.attr(""),
      gender: this.attr(""),
      has_driving_licence_valid_in_switzerland: this.boolean(null).nullable(),
      id: this.attr(null),
      languages: this.attr(""),
      langs: this.attr([]),
      last_name: this.attr(""),
      marital_status: this.attr(""),
      mobile: this.attr(""),
      origin: this.attr(""),
      profession: this.attr(""),
      residence_permit: this.attr(""),
      resides_in_the_canton_since: this.attr(""),
      telephone_contact_person: this.attr(""),
      descriptions: this.attr([]),
      updated_at: this.attr(null),
      is_active: this.boolean(false),
      courses: this.attr([]),
      educated: this.boolean(null).nullable(),
      is_qualified: this.boolean(null).nullable(),
      sector: this.attr("").nullable(),
      experience_years: this.attr("").nullable(),
      work_objective_comment: this.attr("").nullable(),
      study_objective: this.attr("").nullable(),
      study_objective_comment: this.attr("").nullable(),
      integration_objective_comment: this.attr("").nullable(),
    }
  }

  get displayName() {
    return `${this.last_name.toUpperCase()} ${this.first_name}`
  }

  get updated() {
    return Date.parse(this.updated_at)
  }

  static get() {
    return this.api().get("/students", { dataKey: "data" })
  }

  static async getNotSaving() {
    return this.api().get("/students", { dataKey: "data", save: false })
  }

  static async put(updatedStudent) {
    if (updatedStudent.langs?.length > 0) {
      updatedStudent.languages = null
    }
    return await this.api()
      .put(`/students/`, updatedStudent, {
        dataKey: "data",
      })
      .then(() => {
        notify("success", "Sauvegardé")
      })
      .catch((error) => {
        notify("error", error.response.data.error || error.response.data)
      })
  }

  static async post(newStudent) {
    return this.api().post(`/students/`, newStudent)
  }

  static async getOne(studentId) {
    return this.api().get(`/students/${studentId}`, { dataKey: "data", persistBy: "insert" })
  }

  static async deleteOne(studentId) {
    return this.api().delete(`/students/${studentId}`, {
      delete: studentId,
    })
  }
}
